import { IconLayoutDashboard } from '@tabler/icons-react';
import { createFileRoute } from '@tanstack/react-router';
import { useCallback, useMemo } from 'react';

import { Bookmarks } from '#components/bookmarks/Bookmarks';
import type { Bookmark } from '#components/bookmarks/types';
import { useDashboardBookmarks } from '#hooks/useDashboardBookmarks';
import type { DisplayChartsParameters } from '#schema/DisplayChartsTool';

export const Route = createFileRoute('/bookmarks')({
  component: RouteComponent,
  beforeLoad: () => ({
    getTitle: () => 'Bookmarks',
  }),
});

function RouteComponent() {
  const [bookmarks, setBookmarks] = useDashboardBookmarks();

  const bookmarksWithIcons = useMemo<Bookmark<DisplayChartsParameters>[]>(
    () =>
      bookmarks.map((data) => ({
        id: data.title,
        title: data.title ?? 'Unnamed Dashboard',
        icon: <IconLayoutDashboard size={16} />,
        data,
      })),
    [bookmarks],
  );

  const handleDelete = useCallback(
    (bookmark: Bookmark) => {
      setBookmarks((current) => current.filter((item) => item.title !== bookmark.id));
    },
    [setBookmarks],
  );

  return <Bookmarks title="My Dashboards" bookmarks={bookmarksWithIcons} onDelete={handleDelete} />;
}
